import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  HostBinding,
  input,
  model,
  output,
  viewChild,
} from '@angular/core';
import { SKWTranslatePipe } from '../../pipes/storekeeper-window-translate.pipe';
import { StorekeeperButtonComponent } from '../storekeeper-button/storekeeper-button.component';

@Component({
  selector: 'iu-storekeeper-window-panel',
  standalone: true,
  imports: [StorekeeperButtonComponent, SKWTranslatePipe],
  templateUrl: './storekeeper-window-panel.component.html',
  styleUrl: './storekeeper-window-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StorekeeperWindowPanelComponent {
  panel = viewChild<ElementRef>('panel');

  @HostBinding('style.--_panel-height')
  get _panelHeight() {
    return `${this.panel()?.nativeElement?.getBoundingClientRect()?.height}px`;
  }

  isOpen = model(false);
  displayDefaultButtons = model(true);

  title = input<string>(undefined);
  hasTitle = computed(() => this.title()?.length > 0);

  cancelButtonLabel = input('Cancel');
  cancel = output<MouseEvent>();
  confirmButtonLabel = input('Confirm');
  confirm = output<MouseEvent>();

  onClickOutside(event: MouseEvent) {
    this.isOpen.set(false);
    this.onCancel(event);
  }

  onCancel(event: MouseEvent) {
    this.cancel.emit(event);
  }

  onConfirm(event: MouseEvent) {
    this.confirm.emit(event);
  }
}
